"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _combinedDataEdit = _interopRequireDefault(require("./combinedDataEdit.vue"));
var customResourceDefinitionApi = _interopRequireWildcard(require("@/api/customResourceDefinition"));
var _combineDataList = _interopRequireDefault(require("./combineDataList.vue"));
var roleApi = _interopRequireWildcard(require("@/api/tenant"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    edit: _combinedDataEdit.default,
    cmDataList: _combineDataList.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      dataList: {
        list: [],
        total: 0
      },
      selectedTenant: false,
      tenantId: '',
      listData: [],
      listPram: {
        keywords: null,
        page: 1,
        pageSize: this.$constants.page.limit[0]
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建 1=编辑
        editData: {}
      },
      comDataListConfig: {
        visible: false,
        formData: {}
      },
      // 定义一组相近的柔和背景色（淡蓝、淡紫、淡青、淡粉、淡绿）
      cardColors: ['#f0f8ff', '#f0f8ff', '#f0f8ff', '#f0f8ff', '#f0f8ff'],
      // 对应的边框色（与背景色匹配的浅色系）
      borderColors: ['#cfe8ff', '#cfe8ff', '#cfe8ff', '#cfe8ff', '#cfe8ff']
    };
  },
  watch: {
    // 监听路由变化（路径/参数/查询都触发）
    $route: {
      handler: function handler() {
        var tenantId = this.$route.query.tenantId;
        if (!tenantId) {
          this.handlerSearch();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    roleApi.getRoleList({
      page: 1,
      limit: 9999
    }).then(function (data) {
      _this.listData = data.list;
      _this.handlerSearch();
    });
  },
  methods: {
    change: function change() {
      console.log(this.tenantId);
      // 如需无历史记录（替换当前 URL），用 replace：
      this.$router.replace({
        path: this.$route.path,
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          tenantId: this.tenantId
        })
      });
      this.handlerSearch();
    },
    handlerSearch: function handlerSearch() {
      this.listPram.page = 1;
      this.tenantId = '';
      var tenantId = this.$route.query.tenantId;
      if (!tenantId) {
        this.selectedTenant = false;
        return;
      }
      this.selectedTenant = true;
      this.tenantId = parseInt(tenantId);
      this.handlerGetList(this.listPram);
    },
    handlerOpenEdit: function handlerOpenEdit(editData, isCreate) {
      this.editDialogConfig.editData = isCreate === 0 ? {} : _objectSpread({}, editData); // 深拷贝避免原数据被修改
      this.editDialogConfig.isCreate = isCreate;
      this.editDialogConfig.visible = true;
    },
    handlerGetList: function handlerGetList(pram) {
      var _this2 = this;
      if (!this.tenantId) {
        alert("参数不合法！");
        return;
      }
      pram.tenantId = this.tenantId;
      customResourceDefinitionApi.groupList(pram).then(function (data) {
        _this2.dataList = data;
        // 若需要过滤id为54的项，取消下面的注释
        // this.dataList.list = this.dataList.list.filter(item => item.id !== 54)
      });
    },
    handleDataList: function handleDataList(rowData) {
      if (rowData.formId <= 0) {
        return this.$message.error('请先关联表单');
      }
      this.comDataListConfig.formData = _objectSpread({}, rowData); // 深拷贝
      this.comDataListConfig.visible = true;
    },
    handleDelete: function handleDelete(rowData) {
      var _this3 = this;
      rowData.tenantId = this.tenantId;
      this.$confirm('确定删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        customResourceDefinitionApi.groupDelete(rowData).then(function () {
          _this3.$message.success('删除数据成功');
          setTimeout(function () {
            _this3.handlerGetList(_this3.listPram);
          }, 800);
        }).catch(function () {
          _this3.$message.error('删除数据失败');
        });
      }).catch(function () {
        _this3.$message.info('已取消删除');
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.pageSize = val; // 修复原代码的参数名错误（limit → pageSize）
      this.handlerGetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetList(this.listPram);
    },
    handlerHideDialog: function handlerHideDialog() {
      var _this4 = this;
      setTimeout(function () {
        _this4.editDialogConfig.visible = false;
        _this4.handlerGetList(_this4.listPram);
      }, 800);
    }
  }
};